import React from "react";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import closeIcon from "./images/close.svg";
import bulb from "./images/bulb.svg";
import PropTypes from "prop-types";
import useCarHighlightLocation from "../../../hooks/use-car-highlight-location";

const HubLocationModal = ({cityCode, onClose}) => {

    const onCloseClick = () => {
        onClose();
    };

    const { currentCarCityInfo } = useCarHighlightLocation(cityCode);
    const cityHub = currentCarCityInfo || {};

    return (
        <Modal isOpen={true}>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.headerWrapper"}>
                    <p styleName={"styles.heading"}>Hub Location</p>
                    <img onClick={onCloseClick} src={closeIcon} alt="Close modal" />
                </div>
                <div styleName={"styles.blueCardWrapper"}>
                    <p styleName={"styles.cardHeading"}><img src={bulb} alt="Card icon" />Cars24 delivers all around Australia</p>
                    <p styleName={"styles.cardSubHeading"}>You can check cars from all around Australia. We transport the car to your location with transfer fee.</p>
                </div>
                <div styleName={"styles.greyCardWrapper"}>
                    <p styleName={"styles.cardHeading"}>{cityHub?.displayName}</p>
                    <p styleName={"styles.cardSubHeading"}>{cityHub?.address}</p>
                </div>
            </div>
        </Modal>
    );
};

HubLocationModal.propTypes = {
    onClose: PropTypes.func,
    cityCode: PropTypes.string
};

export default HubLocationModal;
